import React, { forwardRef, useReducer } from "react";
import cx from "classnames";
import styled from 'styled-components';
import IBuildrProps from '../../utilities/IBuildrProps';

export interface IChecklistState {
    activeTab: number;
    selections: any[]
};

const initialState: IChecklistState = {
    activeTab: 0,
    selections: [],
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case 'selection': {
            const { type, ...currentSelection } = action;
            let selections = state?.selections || [];
            if (!selections.find(selection => selection.index === currentSelection.index && selection.tabId === state.activeTab)) {
                selections.push(currentSelection);
            } else {
                selections = selections.map(selection => {
                    if (selection.index === action.index && selection.tabId === state.activeTab) {
                        return {
                            ...selection,
                            ...currentSelection,
                        };
                    }

                    return selection;
                });
            }

            return {
                ...state,
                selections,
            };
        }
        case 'general_update': {
            return {
                ...state,
                ...action.payload,
            };
        }
        default:
            return { ...state };
    }
}

interface IChecklistProps extends IBuildrProps {
    children: any;
}

export default styled(forwardRef((props: IChecklistProps, ref: any) => {
    const { cmsId, editorClassObj, className, children } = props;

    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <div ref={ref} data-id={cmsId} className={cx('wrapper px-1 px-sm-4 py-5', className, editorClassObj)}>
            <h2 className="text-serif text-primary px-3 m-0">Choose your experience</h2>
            <div className="experiences-wrap">
                {React.Children.map(children,(child, index) => {
                    return React.cloneElement(child, {
                        state,
                        dispatch,
                        tabId: index,
                        selected: state.activeTab === index,
                        width: `${(100 / children.length)}%`,
                    });
                })}
            </div>
        </div>
    );
}))`
max-width: 930px;

.experiences-wrap {
    display: flex;
    flex-flow: wrap;
}`;
